import React from 'react';
import { SpeedDial, SpeedDialAction } from '@mui/material';

import { IconWrapper } from 'components/Icon';

const actionSx = ({ palette }) => ({
  bgcolor: palette.grey[50],
  '&:hover': { bgcolor: palette.grey[200] },
});

const actionIconSx = ({ palette }) => ({
  svg: { width: 20, height: 20, stroke: palette.grey[500], color: palette.grey[500] },
});

export const RowActions = ({ name, onEdit, onDelete }) => (
  <SpeedDial
    onClick={(e) => e.stopPropagation()}
    direction="left"
    ariaLabel={`Actions for ${name}`}
    icon={
      <IconWrapper
        icon="elipsisVertical"
        sx={({ palette }) => ({
          svg: { stroke: palette.grey[500], color: palette.grey[500] },
        })}
      />
    }
    sx={({ palette }) => ({
      '.MuiSpeedDial-actions': {
        bgcolor: 'white',
        borderRadius: 4,
        pr: 0,
        mr: 0,
        border: `1px solid ${palette.grey[200]}`,
      },
      '.MuiSpeedDial-actionsClosed': { bgcolor: 'transparent', border: 'none' },
      '& > button': {
        boxShadow: 'none',
        bgcolor: palette.background.paper,
        width: 36,
        height: 36,
      },
      '& > button:hover': { bgcolor: palette.background.paper },
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 28px)',
      zIndex: 1,
    })}
  >
    <SpeedDialAction
      tooltipTitle="Edit"
      onClick={onEdit}
      sx={actionSx}
      icon={<IconWrapper icon="edit" sx={actionIconSx} />}
    />
    {onDelete && (
      <SpeedDialAction
        tooltipTitle="Delete"
        onClick={onDelete}
        sx={actionSx}
        icon={<IconWrapper icon="trash" sx={actionIconSx} />}
      />
    )}
  </SpeedDial>
);
